import { Emoji, NormalizedParticipant, Participant } from 'src/app/types'
import { getBadgeEmojiFromName } from './helpers'

// Step 1
const flattenData = (
  participantsArr: Participant[],
  selectedKeys?: Set<string>
) => {
  /**
   * initialize a new set because we only care about the unique badges in the session. we will use this as the column header in the CSV
   **/
  const badgeSet = new Set()
  const normalizedParticipants = []
  for (const { screenName, badges } of participantsArr) {
    // csv column headers begin with name of participant, all
    const newObject: NormalizedParticipant = { Participant: screenName, All: 0 }

    for (const obj of badges) {
      // convert emoji string code to real emoji
      const emoji = getBadgeEmojiFromName(obj.name)
      // when there is no selectedKeys provided = we want calculate all badges
      // when selectedKeys is provided but the length is 0 = we don't want to calculate any badges
      // no selectedKeys != selectedKeys with size of 0
      if (!selectedKeys || (selectedKeys.size > 0 && selectedKeys.has(emoji))) {
        newObject[emoji] = obj.count
        newObject['All'] += obj.count
        badgeSet.add(emoji)
      }
    }
    normalizedParticipants.push(newObject)
  }

  const allBadges = [...badgeSet] as Emoji[]
  return { allBadges, normalizedParticipants }
}

// Step 2
const calculateTotalBadges = (
  allBadges: Emoji[],
  normalizedParticipants: NormalizedParticipant[]
) => {
  const totalBadges: NormalizedParticipant = {
    Participant: 'Total',
    All: 0,
  }

  let finishFirstRound = false

  for (const badge of allBadges) {
    for (const obj of normalizedParticipants) {
      // if there is no badge exist for some participants, we add the badge with value of 0
      obj[badge] = obj[badge] || 0
      // sum total badges for each participant
      totalBadges[badge] = (totalBadges[badge] || 0) + obj[badge]!

      if (!finishFirstRound) {
        // sum the total badges for all participants
        totalBadges['All'] += obj['All']
      }
    }
    // when finish first iteration of the participant data, we already have summed the total badge of all participants
    finishFirstRound = true
  }

  normalizedParticipants.sort((a, b) => b.All - a.All)
  normalizedParticipants.push(totalBadges)
}

// Main
export const normalizeParticipantData = (
  participantsArr: Participant[],
  selectedKeys?: Set<string>
) => {
  const { allBadges, normalizedParticipants } = flattenData(
    participantsArr,
    selectedKeys
  )
  calculateTotalBadges(allBadges, normalizedParticipants)
  return { normalizedParticipants, allBadges }
}
